<template>
  <button
    :style="buttonColors"
    :disabled="disabledAttr"
    type="button"
    @mouseenter="assignHoverColor(true)"
    @mouseleave="assignHoverColor(false)"
  >
    <slot />
  </button>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "PrimaryButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showButtonHover: false
    };
  },
  computed: {
    ...mapState("campaign", {
      campaignDesignColors: state => state.campaignDesignColors
    }),
    buttonColors() {
      let background = this.campaignDesignColors.submitButtonBackground;
      if (this.showButtonHover && !this.isMobile) {
        background = this.campaignDesignColors.submitButtonHover;
      }

      return {
        background,
        color: this.campaignDesignColors.submitButtonText
      };
    },
    disabledAttr() {
      return this.disabled ? "disabled" : false;
    }
  },
  methods: {
    assignHoverColor(bool) {
      this.showButtonHover = bool;
    }
  }
};
</script>
